import React from 'react'
import { Link } from 'react-router-dom'

// project imports
import StencilBox from '../../components/stencils/StencilBox'
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne'
import { GoogleAnalyticsEnum } from '../../utils/google-analytics'
import SEO from '../../common/SEO'
import Layout from '../../common/Layout'
import EBookListingOneStencil from '../../components/ebooks/EBookTypeOneStencil'

function EBookListingsStencil() {
    return (
        <>
            <SEO title="E-Books | Longswitch Academy" url={process.env.REACT_APP_META_URL + "e-books"} /> {/* Set SEO title */}
            <Layout>
                <BreadcrumbOne
                    title="Our E-Books" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    googleEnum={GoogleAnalyticsEnum.SF_ALL_COURSES_TO_SF_COURSE_HOME}
                    currentUrl="E-Books"
                    extraClass="container-xs"
                />
                <div className="edu-elements-area edu-course-area edu-section-gap bg-color-white pb-150">
                    <div className="container container-xs edu-course-area">
                        <div className="row y-gap-15 g-5 align-items-center justify-content-between mb--45 mb--30 mt_md--30 mt_sm--30">
                            <div className="col-lg-6">
                                <StencilBox
                                    className="pre-title stencil-sm-devic mb--10"
                                    width="20%"
                                    height="26px"
                                    backgroundColor="#6f6b80"
                                />
                                <StencilBox
                                    className="pre-title stencil-sm-devic"
                                    width="50%"
                                    height="56px"
                                    backgroundColor="#6f6b80"
                                />
                            </div>
                            <div className="col-lg-6">
                                <div className="pricing-billing-duration">
                                    <Link className="edu-btn-stencil">
                                        <StencilBox
                                            className=" sf-blog-btn-stencil"
                                            width="223px"
                                            height="60px"
                                            backgroundColor="#6f6b80"
                                        />
                                    </Link>

                                </div>
                            </div>
                        </div>
                        <div className="row y-gap-40 pt--50">

                            {/* Right side bar Ebook Listing */}
                            <div className="col-lg-9 order-2">
                                <div className="row y-gap-40 ">
                                    {[1, 2, 3, 4, 5, 6].map((_, i) => (
                                        <div className="col-12 col-sm-6 col-lg-4" key={i}>
                                            <EBookListingOneStencil />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Left side bar (Search & Category) */}
                            {

                                <div className="col-lg-3">
                                    <aside className="edu-blog-sidebar">

                                        <div className={`edu-blog-widget widget-search`}>
                                            <div className="inner">
                                                <h5 className="widget-title  placeholder-glow">
                                                    <span className="placeholder w-100"></span>
                                                </h5>
                                                {/* <h5 className="widget-title ">Search Here</h5> */}
                                                <div className="content">
                                                    <form className="blog-search" action="#">
                                                        <div className="price w-50 h-100 placeholder placeholder-glow "></div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Category */}
                                        <div class={`edu-blog-widget-2 widget-categories mt--20`}>
                                            <div class="inner">
                                                <h5 className="placeholder-glow mb--30">
                                                    <span className="placeholder w-50 "></span>
                                                </h5>
                                                <div class="content">
                                                    <ul class="category-list">

                                                        <li>
                                                            <div className="w-100 d-flex gap-3 align-items-center justify-content-between mt--10">
                                                                <div className="price w-50 h-100 placeholder placeholder-glow "></div>
                                                                <div className="price w-25 h-100 placeholder placeholder-glow "></div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="w-100 d-flex gap-3 align-items-center justify-content-between mt--10">
                                                                <div className="price w-50 h-100 placeholder placeholder-glow "></div>
                                                                <div className="price w-25 h-100 placeholder placeholder-glow "></div>
                                                            </div>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </aside>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default EBookListingsStencil
